import type { ActiveFacilities } from '../../API/services/FacilityUserService';

const facilityUserInitialValues = {
  id: 0,
  firstName: '',
  lastName: '',
  primaryEmail: '',
  username: '',
  roleId: 0,
  facilityId: 0,
  managedFacilityIds: [] as ActiveFacilities[],
  status: true,
  password: '',
  notes: '',
  mfaEnabledByAdmin: true,
  isLocked: false,
};
export default facilityUserInitialValues;
